namespace Matrix.Visualizer {
    export interface GraphThemeRow {
        ThemeKey?: string;
        Description?: string;
        BackgroundColour?: string;
        EdgeColour?: string;
        NodeColour?: string;
        LeafNodeColour?: string;
        RootNodeColour?: string;
        NodeTextColour?: string;
        NodeBorderColour?: string;
        HighlightColour?: string;
        DefaultContextMenu?: string;
        DefaultContextMenuItems?: GraphContextMenuItem[];
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace GraphThemeRow {
        export const idProperty = 'ThemeKey';
        export const nameProperty = 'Description';
        export const localTextPrefix = 'Visualizer.GraphTheme';
        export const lookupKey = 'Visualizer.GraphTheme';

        export function getLookup(): Q.Lookup<GraphThemeRow> {
            return Q.getLookup<GraphThemeRow>('Visualizer.GraphTheme');
        }
        export const deletePermission = 'DataAdmin:Visualizer';
        export const insertPermission = 'DataAdmin:Visualizer';
        export const readPermission = 'Read:Visualizer';
        export const updatePermission = 'DataAdmin:Visualizer';

        export declare const enum Fields {
            ThemeKey = "ThemeKey",
            Description = "Description",
            BackgroundColour = "BackgroundColour",
            EdgeColour = "EdgeColour",
            NodeColour = "NodeColour",
            LeafNodeColour = "LeafNodeColour",
            RootNodeColour = "RootNodeColour",
            NodeTextColour = "NodeTextColour",
            NodeBorderColour = "NodeBorderColour",
            HighlightColour = "HighlightColour",
            DefaultContextMenu = "DefaultContextMenu",
            DefaultContextMenuItems = "DefaultContextMenuItems",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
